"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _HBSidePanelProvider = require("./HBSidePanelProvider");
var _HBSidePanelCloseButton = _interopRequireDefault(require("./HBSidePanelCloseButton"));
var _HBSidePanelHeader = _interopRequireDefault(require("./HBSidePanelHeader"));
var _HBSidePanelBody = _interopRequireDefault(require("./HBSidePanelBody"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _variables = require("../../styles/variables");
var _useSidePanelOpenState = require("./hooks/useSidePanelOpenState");
var _useResizableWidth3 = require("./hooks/useResizableWidth");
var _HBSidePanel = require("./HBSidePanel.consts");
var _HBSidePanelExpandButton = require("./HBSidePanelExpandButton");
var _animations = require("../../styles/animations");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var HBSidePanel = function HBSidePanel(_ref) {
  var children = _ref.children,
    isOpen = _ref.isOpen,
    _ref$isResizable = _ref.isResizable,
    isResizable = _ref$isResizable === void 0 ? false : _ref$isResizable,
    minWidth = _ref.minWidth,
    onClose = _ref.onClose,
    width = _ref.width;
  var _useSidePanelOpenStat = (0, _useSidePanelOpenState.useSidePanelOpenState)({
      isOpen: isOpen,
      onClose: onClose
    }),
    closeSidePanel = _useSidePanelOpenStat.closeSidePanel,
    internalIsOpen = _useSidePanelOpenStat.internalIsOpen,
    onTransitionEnd = _useSidePanelOpenStat.onTransitionEnd;
  var _useResizableWidth = (0, _useResizableWidth3.useResizableWidth)({
      initialWidth: width,
      isResizable: isResizable,
      minWidth: minWidth
    }),
    _useResizableWidth2 = (0, _slicedToArray2["default"])(_useResizableWidth, 1),
    currentWidth = _useResizableWidth2[0];
  var sidePanel = /*#__PURE__*/_react["default"].createElement(_HBSidePanelProvider.HBSidePanelProvider, {
    closeSidePanel: closeSidePanel
  }, /*#__PURE__*/_react["default"].createElement(FixedContainer, {
    style: {
      width: "".concat(currentWidth, "px")
    },
    isOpen: internalIsOpen,
    "data-testid": "side-panel-container",
    onTransitionEnd: onTransitionEnd,
    className: _HBSidePanel.SIDE_PANEL_CLASS
  }, children, isResizable && /*#__PURE__*/_react["default"].createElement(ResizeHandle, {
    className: _HBSidePanel.SIDE_PANEL_RESIZE_HANDLE_CLASS_NAME
  })));
  return /*#__PURE__*/(0, _reactDom.createPortal)(sidePanel, document.body);
};
var HBSidePanelWithCompound = HBSidePanel;
HBSidePanelWithCompound.Body = _HBSidePanelBody["default"];
HBSidePanelWithCompound.Header = _HBSidePanelHeader["default"];
HBSidePanelWithCompound.CloseButton = _HBSidePanelCloseButton["default"];
HBSidePanelWithCompound.ExpandButton = _HBSidePanelExpandButton.HBSidePanelExpandButton;
var _default = exports["default"] = HBSidePanelWithCompound; // -------------------------------- Styles -------------------------------- //
var FixedContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBSidePanel__FixedContainer",
  componentId: "sc-la8gc9-0"
})(["position:fixed;z-index:", ";max-width:90%;top:0;right:0;bottom:0;background-color:", ";transform:translateX(", ");transition:transform 240ms cubic-bezier(0.4,0,0.93,0.5);", " box-shadow:0px 20px 40px rgba(0,0,0,0.1),-1px 0px 0px rgba(23,23,26,0.08);display:flex;flex-direction:column;"], _variables.Z_INDEX.FULL_SCREEN, _colors["default"].white, function (_ref2) {
  var isOpen = _ref2.isOpen;
  return isOpen ? 0 : '100%';
}, function (_ref3) {
  var isOpen = _ref3.isOpen;
  return !isOpen && (0, _styledComponents.css)(["transition:transform 300ms cubic-bezier(0.08,0.4,0.2,1);"]);
});
var ResizeHandle = _styledComponents["default"].div.withConfig({
  displayName: "HBSidePanel__ResizeHandle",
  componentId: "sc-la8gc9-1"
})(["width:16px;position:absolute;z-index:", ";top:0;left:0;bottom:0;cursor:ew-resize;border-left:2px solid;border-left-color:", ";", ";&:hover,&.", "{border-left-color:", ";}"], _variables.Z_INDEX.FULL_SCREEN + 1, _colors["default"].transparent, (0, _animations.transition)('border-left-color'), _HBSidePanel.SIDE_PANEL_RESIZE_HANDLE_DRAGGING_CLASS_NAME, _colors["default"].blue20);
//# sourceMappingURL=HBSidePanel.js.map